import styled from "styled-components";
import colors from "assets/styles/colors";

export default styled.div`
    .item {
        margin-bottom: 10px;
        max-width: 250px;
    }
`;
